import { useFormik } from 'formik'
import React from 'react'
import ModalComponent from '..'
import { Button } from '../../button'
import { TextInput } from '../../inputs/textInput'

import { useSendVouchersMutation } from '../../../redux-toolkits/voucher/voucher.slice'
import { SendVouchersSchema } from '../../../validation/validate'

import { NumericFormat } from 'react-number-format'
import {
  getCurrencySymbol,
  parseCurrencyToNumber,
  removeElementAtIndex,
} from '../../../helpers'
import Icon from '../../icon'

export const SendVouchersModal: React.FC<{
  open: boolean
  setOpen: (val: boolean) => void
  onCloseCallback?: () => void
  onSuccessCallback?: () => void
}> = ({
  open,
  setOpen,
  onCloseCallback = () => {},
  onSuccessCallback = () => {},
}) => {
  const [sendVouchers, { isLoading }] = useSendVouchersMutation()
  const {
    values,
    errors,
    handleSubmit,
    handleChange,
    handleBlur,
    touched,
    isValid,
    resetForm,
    setFieldValue,
  } = useFormik({
    initialValues: {
      value: '',
      emails: [],
    },
    enableReinitialize: true,
    validationSchema: SendVouchersSchema,
    onSubmit: async (values, { resetForm }) => {
      const resp = await sendVouchers({
        ...values,
        value: parseCurrencyToNumber(values.value),
      })

      if (resp.data?.success) {
        resetForm()
        onSuccessCallback()
      }
    },
  })
  return (
    <ModalComponent
      open={open}
      setOpen={setOpen}
      onCloseCallback={() => {
        resetForm()
        onCloseCallback()
      }}
      title={'Send Vouchers'}
      childrenClassName="md:!max-w-[420px]"
    >
      <div className="flex flex-col gap-4">
        <NumericFormat
          suffix={undefined}
          prefix={getCurrencySymbol('NGN')}
          decimalScale={2}
          thousandSeparator
          customInput={TextInput}
          type="text"
          name="value"
          placeholder="Enter voucher value (Amount)"
          value={values.value}
          onBlur={handleBlur}
          onChange={handleChange}
          errors={errors.value && touched.value ? errors.value : ''}
          hasIcon={false}
          className="!border-divider-gray !w-full"
        />

        <div className="flex flex-col gap-4">
          {values.emails.map((value, index) => {
            const key = `${index}`

            return (
              <div key={key} className="flex items-center gap-2">
                <div className="flex-1">
                  <TextInput
                    type="text"
                    name={`emails[${index}]`}
                    placeholder="Enter email address"
                    value={String(value)}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    errors={
                      errors.emails && touched.emails
                        ? errors.emails[index]
                        : ''
                    }
                    hasIcon={false}
                    className=""
                  />
                </div>

                <button
                  type="button"
                  onClick={() => {
                    const valuesCopy = JSON.parse(JSON.stringify(values.emails))

                    setFieldValue(
                      'emails',
                      removeElementAtIndex(valuesCopy, index),
                    )
                  }}
                >
                  <Icon
                    id="close-icon"
                    width={14}
                    height={14}
                    className="text-danger"
                  />
                </button>
              </div>
            )
          })}
          <button
            type="button"
            className="flex items-center gap-2"
            onClick={() => {
              setFieldValue('emails', [...values.emails, ''])
            }}
          >
            Add email
            <Icon
              id="plus"
              width={20}
              height={20}
              className="border rounded-full p-0.5 border-black"
            />
          </button>
        </div>

        <Button
          label="Proceed"
          type="button"
          className="mt-10"
          disabled={!isValid || isLoading}
          loading={isLoading}
          primary
          onClick={() => {
            handleSubmit()
          }}
        />
      </div>
    </ModalComponent>
  )
}
